module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEySURBVFhH7ZahTgNRFEQ3JKjaChS61fh+ALa+mromfAC2Hl/dH8Ciq2uQdSTIugoCzG3ybl6672ZnmtcNJJzkhHSZmb2pavPPb+X7QtKUyjWkSYUHuIbv2bOkPbP/WaaL1KEpFUYwOqgLNucwBTuIHWZzTu1hNufUHmZzTu1hNufUHmZzTs3hG8juOWyhK2cvf4OWsb80tQ7IX27H0LAHfEHLLY6f2qQd6eUGe4C9OGVLR7A7LZRiOsK+jVN6OcCI8uqOoxajvLrjqMUor+44ajHKqzuOWozy6o6jFqO8uuOoxSiv7jhqMcqrO04qvsAneA+HMCLlI2U+YGloB+1H6SOcwAE0Stncs7iFU7iEr3APT4c/4Tb7fFGu4BjO4DPcwAPMD+qda3gH53BlD/4YTfMDo1TjMUooXjAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/folder.png
// module id = 922
// module chunks = 0